module.exports = __webpack_public_path__ + "static/11 - msu-93fef43d8231fd3ee93af4ecde8dc7b3.jpg";